









import { Component, Vue, Watch } from 'vue-property-decorator';
import simpleheat from 'simpleheat';
import ApiHandler from '@/logic/ApiHandler';
import GlobalEvents from '@/logic/GlobalEvents';

/**
 * Overlay of heatmap
 */
@Component
export default class HeatmapOverlay extends Vue {

    // Fit to screen
    private winWidth = window.innerWidth;
    private winHeight = window.innerHeight;

    // Heatmap instance
    private heatmap;

    // Cache global data to reduce fetching when switching between local and global
    private heatmapDataGlobal: any[] = [];
    private heatmapDataGlobalSet: boolean = false;

    private heatmapMaxGlobal = 16;
    private heatmapMaxLocal = 3;

    private mounted() {

        // Init empty heatmap
        this.heatmap = simpleheat('heatmap');

        // Register refresh listener
        GlobalEvents.$on('refresh-heatmap-overlay', this.refresh);
    }

    // Update on toggle
    @Watch('isHeatmapActive')
    private onHeatmapActiveChanged() {
        this.draw();
    }

    // Update on toggle
    @Watch('isHeatmapGlobal')
    private onHeatmapGlobalChanged() {
        this.draw();
    }

    private get isHeatmapActive() {
        return this.$store.getters['analytics/getShowHeatmapOverlay'];
    }

    private get isHeatmapGlobal() {
        return this.$store.getters['analytics/getHeatmapOverlayGlobal'];
    }

    private get heatmapData() {

        if (this.isHeatmapGlobal) {

            if (this.heatmapDataGlobalSet) {
                return this.heatmapDataGlobal;
            } else {
                this.refresh();

                // Return empty dataset for now
                return [];
            }
        } else {
            return this.$store.getters['analytics/getHeatmapData'];
        }
    }

    // Get new data and redraw
    private async refresh() {

        if (this.isHeatmapGlobal) {
            this.heatmapDataGlobal = await ApiHandler.fetchGlobalHeatmapData();
            this.heatmapDataGlobalSet = true;
        }

        this.draw();
    }

    private get heatmapMax() {

        if (this.isHeatmapGlobal) {
            return this.heatmapMaxGlobal;
        } else {
            return this.heatmapMaxLocal;
        }
    }

    // Draw the heatmap using the currently selected data
    private draw() {

        // Redraw heatmap
        this.heatmap.data(this.heatmapData).max(this.heatmapMax).draw();
    }

}
